export async function getCookie(name: string): Promise<string | undefined> {
	if (typeof cookieStore === "undefined") {
		const { parse } = await import("cookie");
		const cookies = parse(document.cookie);
		return cookies[name];
	}

	return (await cookieStore.get(name))?.value;
}
